import { SingleMetricWidget } from "app/components/widget/widget-types/SingleMetricWidget";
import SearchOverviewTotalVisitsDataFetcherFactory from "app/components/widget/widget-fetchers/SearchOverviewTotalVisitsDataFetcher";

export class SearchOverviewTotalVisitsWidget extends SingleMetricWidget {
    static getWidgetMetadataType() {
        return "SearchOverviewTotalVisits";
    }

    static getWidgetResourceType() {
        return "SingleMetric";
    }

    static getWidgetDashboardType() {
        return "SingleMetric";
    }

    constructor() {
        super();
    }

    private dataFetcherFactory() {
        return SearchOverviewTotalVisitsDataFetcherFactory;
    }

    public getFetcherFactory() {
        return this.dataFetcherFactory();
    }
}

SearchOverviewTotalVisitsWidget.register();
